export const PANEL_ID = 'ai-text-prompt-box-panel';
